import { render, staticRenderFns } from "./ConsultaItemBemPermanenteList.vue?vue&type=template&id=63c42d4a"
import script from "./ConsultaItemBemPermanenteList.vue?vue&type=script&lang=js"
export * from "./ConsultaItemBemPermanenteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports